<template>
    <a
        :class="[
            'iu-link',
            type ? `iu-link--${type}` : '',
            disabled && 'is-disabled',
            underline && !disabled && 'is-underline',
        ]"
        :href="disabled ? null : href"
        v-bind="$attrs"
        @click="handleClick"
    >
        <i :class="icon" v-if="icon"></i>

        <span v-if="$slots.default" class="iu-link--inner">
            <slot></slot>
        </span>

        <template v-if="$slots.icon">
            <slot v-if="$slots.icon" name="icon"></slot>
        </template>
    </a>
</template>

<script>
export default {
    name: 'IuLink',
    props: {
        type: {
            type: String,
            default: 'default',
        },
        underline: {
            type: Boolean,
            default: true,
        },
        disabled: Boolean,
        href: String,
        icon: String,
    },
    methods: {
        handleClick(event) {
            if (!this.disabled) {
                if (!this.href) {
                    this.$emit('click', event);
                }
            }
        },
    },
};
</script>

<style scope>
.iu-link {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    text-decoration: none;
    outline: 0;
    cursor: pointer;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
}
.iu-link.is-underline:hover:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 0;
    bottom: 0;
    border-bottom: 1px solid #409eff;
}
.iu-link.iu-link--default:after,
.iu-link.iu-link--primary.is-underline:hover:after,
.iu-link.iu-link--primary:after {
    border-color: #409eff;
}
.iu-link.is-disabled {
    cursor: not-allowed;
}
.iu-link [class*='iu-icon-'] + span {
    margin-left: 5px;
}
.iu-link.iu-link--default {
    color: #606266;
}
.iu-link.iu-link--default:hover {
    color: #409eff;
}
.iu-link.iu-link--default.is-disabled {
    color: #c0c4cc;
}
.iu-link.iu-link--primary {
    color: #409eff;
}
.iu-link.iu-link--primary:hover {
    color: #66b1ff;
}
.iu-link.iu-link--primary.is-disabled {
    color: #a0cfff;
}
.iu-link.iu-link--danger.is-underline:hover:after,
.iu-link.iu-link--danger:after {
    border-color: #f56c6c;
}
.iu-link.iu-link--danger {
    color: #f56c6c;
}
.iu-link.iu-link--danger:hover {
    color: #f78989;
}
.iu-link.iu-link--danger.is-disabled {
    color: #fab6b6;
}
.iu-link.iu-link--success.is-underline:hover:after,
.iu-link.iu-link--success:after {
    border-color: #67c23a;
}
.iu-link.iu-link--success {
    color: #67c23a;
}
.iu-link.iu-link--success:hover {
    color: #85ce61;
}
.iu-link.iu-link--success.is-disabled {
    color: #b3e19d;
}
.iu-link.iu-link--warning.is-underline:hover:after,
.iu-link.iu-link--warning:after {
    border-color: #e6a23c;
}
.iu-link.iu-link--warning {
    color: #e6a23c;
}
.iu-link.iu-link--warning:hover {
    color: #ebb563;
}
.iu-link.iu-link--warning.is-disabled {
    color: #f3d19e;
}
.iu-link.iu-link--info.is-underline:hover:after,
.iu-link.iu-link--info:after {
    border-color: #909399;
}
.iu-link.iu-link--info {
    color: #909399;
}
.iu-link.iu-link--info:hover {
    color: #a6a9ad;
}
.iu-link.iu-link--info.is-disabled {
    color: #c8c9cc;
}
</style>
